export default "__VITE_ASSET__fnW2o_N8__"